"use strict";function newMsgNotificationStatus$(t){return ddSdk_1.ddSdk.invokeAPI(apiName,t)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.newMsgNotificationStatus$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.newMsgNotificationStatus";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.20"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.20"},_a)),exports.newMsgNotificationStatus$=newMsgNotificationStatus$,exports.default=newMsgNotificationStatus$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/newMsgNotificationStatus.js
// module id = 950
// module chunks = 106